import { useParams } from 'react-router-dom';
import { useContext, useEffect, useState, useRef } from 'react';
import { QRCode } from '@progress/kendo-react-barcodes';
import { exportImage } from '@progress/kendo-drawing';

import {
  NotificationContent,
  NotificationContext
} from '../../contexts/notification';
import { ArGameNames } from '../../constants/argame';
import { GameDocumentContext } from '../../contexts/game-document';

export const QRPage = () => {
  const { gameCode, qrPage } = useParams();
  const [gameDocument] = useContext(GameDocumentContext);
  const [, setNotification] = useContext(NotificationContext);
  const [url, setUrl] = useState<string>('');
  const qrRef = useRef<QRCode>(null);

  const notificationHandler = (message: string) => {
    const responseTeamNotification: NotificationContent = {
      icon: 'notifications',
      isHide: false,
      message: (
        <span>
          <strong>{message}</strong>
        </span>
      )
    };
    setNotification((prevNotification) => ({
      ...prevNotification,
      content: [...prevNotification.content, responseTeamNotification]
    }));
  };

  const handleDownloadQr = () => {
    if (qrRef.current) {
      const visual = qrRef.current.exportVisual();
      exportImage(visual)
        .then((dataUri) => {
          const link = document.createElement('a');
          const fileNamePrefix = gameCode ? gameCode.toLowerCase() + '-' : '';

          link.download = `${fileNamePrefix}qrcode.png`;
          link.href = dataUri;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          notificationHandler('QR Code downloaded!');
        })
        .catch((err) => {
          console.error('Failed to download QR Code', err);
        });
    }
  };

  useEffect(() => {
    const url = (() => {
      switch (qrPage) {
        case 'game':
          if (ArGameNames.includes(gameDocument.gameDocument?.name!))
            return `arpyramid://catalystglobal?${window.location.origin}?${gameCode}`;

          return `${window.location.origin}/games/${gameCode}`;
        case 'preload':
          return `${window.location.origin}/preload/${gameCode}`;
        case 'assessment-facilitator':
          return `${window.location.origin}/facilitator/assessment/${gameCode}`;
        default:
          return '';
      }
    })();
    setUrl(url);
  }, [gameDocument.gameDocument?.name, gameCode, qrPage]);

  return (
    <div
      className={
        'd-flex h-100 w-100 justify-content-center align-items-center pr-0'
      }>
      <div>
        <div
          style={{
            background: 'white',
            padding: '16px',
            display: 'inline-block'
          }}>
          <QRCode ref={qrRef} size={350} value={url} errorCorrection="M" />
        </div>
        <div className={'input-group mb-3 mt-3'}>
          <input
            type={'text'}
            className={'form-control text-primary'}
            disabled={true}
            value={url}
          />
          <div className={'input-group-append'}>
            <button
              className={'btn btn-success text-light'}
              type={'button'}
              onClick={() => {
                navigator.clipboard.writeText(url);
                notificationHandler('URL copied!');
              }}>
              Copy
            </button>
            <button
              className={'btn btn-primary text-light ms-2'}
              type={'button'}
              onClick={handleDownloadQr}>
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
